module.exports = __webpack_public_path__ + "img/calming-influence.a021a586.svg";